export type TagAdapterThemeColors = {
  background: string;
  brackets: string;
  tag: string;
  attribute: string;
  unrecognizedAttribute: string;
  value: string;
  appliedValue: string;
  equals: string;
  quote: string;
};

export const tagAdapterDefaultTheme: TagAdapterThemeColors = {
  background: "#1D2331",
  brackets: "#D4D2C8",
  tag: "#73D0FF",
  attribute: "#FFD173",
  unrecognizedAttribute: "#FF9800",
  value: "#D5FF80",
  appliedValue: "#B800FF",
  equals: "#FFAD66",
  quote: "#D5FF80",
};
